module.exports = __webpack_public_path__ + "img/tucson-25.d915b3e4.png";